<template>
    <NuxtPage />
</template>

<script setup lang="ts">
    import {useRoute} from '@typed-router';
    import {definePageMeta, useAmplitudeSessionReplay} from '#imports';
    import forwardQueryParameters from '~/features/advanced-search/middleware/forwardQueryParameters';

    const route = useRoute();
    useAmplitudeSessionReplay(() => route.name === 's-advanced' || route.name.startsWith('s-advanced-briefId'));

    definePageMeta({
        layout: false,
        middleware: ['auth', forwardQueryParameters],
        enforcedIdentity: () => ({strategy: 'client'}),
        allowUnloggedIfNoEnforcedIdentity: true,
        forbidAccessIfCompanyIsSuspended: true,
        identityRedirect: '/',
    });
</script>
